import type { DeleteImpactsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteImpactsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteObligationImpact = createMutationHook({
  name: 'deleteObligationImpacts',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligationImpact.delete.mutationOptions({ onSuccess }),
  mapInput: (variables: { ids: string[] }) => ({ ids: variables.ids }),
  invalidate: (trpc) => [
    trpc.frontend.obligationImpact.getByParentId.queryKey(),
    // COI-471 parity: Apollo twin also evicts `obligation`.
    trpc.frontend.obligation.pathKey(),
  ],
  // Both branches return the document's `delete_obligation_impact` shape.
  // Consumers ignore the payload, but keeping the tRPC branch consistent with
  // the Apollo document (rather than the unrelated `delete_impact` shape) avoids
  // a latent cross-path mismatch.
  mapResponse: (result: { affected_rows: number }): DeleteImpactsMutation => ({
    delete_obligation_impact: {
      __typename: 'obligation_impact_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteImpactsDocument,
  graphqlVariables: (variables: { ids: string[] }) => ({
    Ids: variables.ids,
  }),
  evictFields: ['obligation_impact', 'obligation'],
});
